__turbopack_context__.v({
  "large": "LoadingRegion-module__yDPBua__large",
  "letter": "LoadingRegion-module__yDPBua__letter",
  "partyamt-loading-dance": "LoadingRegion-module__yDPBua__partyamt-loading-dance",
  "shape": "LoadingRegion-module__yDPBua__shape",
});
